import React, { useContext } from "react";
import VylabsIcon from "../../Assets/Images/VybogTAL-Logo.svg";
import vybogTALDarkLogo from "../../Assets/Images/VybogTAL-Logo-Dark.svg";
import "./Signup.css";
import { useFormik } from "formik";
import Button from "../../Common/Button/Button";
import continueIcon from "../../Assets/Images/continue-arrow-icon.png";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import backIcon from "../../Assets/Images/arrow-right.png";
import { DynamicContext } from "../../Context/DynamicContext";
import accountIcon from "../../Assets/Images/accout-holder-icon.png";
import ownerIcon from "../../Assets/Images/signup-owner-icon.png";
import managerIcon from "../../Assets/Images/signup-manager-icon.png";
function SignupType() {
  const { setSignupCompleted, isDarkMode } = useContext(DynamicContext);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      selectedRole: "",
    },
    onSubmit: (values) => {
      setSignupCompleted(false);
      if (values.selectedRole === "admin") {
        navigate("/admin-signup");
      } else if (values.selectedRole === "member") {
        navigate("/member-signup");
      } else {
        Toast("error", "Please select an option to continue");
      }
    },
  });

  const handleRoleSelect = (role) => {
    formik.setFieldValue("selectedRole", role);
  };
  return (
    <div
      className={`signup-outer-container ${isDarkMode ? "no-bg-image" : ""}`}
    >
      <div className="signup-icon-text">
        <img
          alt="VylabsIcon"
          src={isDarkMode ? vybogTALDarkLogo : VylabsIcon}
          className="vy-labs-logo"
        />
        <div className="signup-welcome-container">
          <h2 className="signup-main-header">
            Welcome to the future of recruitment
          </h2>
          <span className="signup-side-text">
            Smarter hiring starts here. Find, evaluate, and hire talent faster.
          </span>
        </div>
      </div>
      <div className="select-signup-container">
        <div className="select-signup-outer-main-container">
          <div className="signup-header-section">
            <img src={accountIcon} alt="accountIcon" />
            <div className="signup-header-texts">
              <h2 className="signup-main-header">
                Select the option that applies to you
              </h2>
              <span className="signup-side-text">
                Your journey to smarter hiring starts here
              </span>
            </div>
          </div>
          <div className="signup-role-section">
            <div
              className={`select-role-outer-container ${
                formik.values.selectedRole === "admin" ? "selected-role" : ""
              }`}
              onClick={() => handleRoleSelect("admin")}
            >
              <img src={ownerIcon} alt="ownerIcon" />
              <div className="role-text-checkbox-container">
                <div className="role-text-content">
                  <h3 className="signup-main-header">
                    I'm the admin of an organisation
                  </h3>
                  <span className="signup-side-text">
                    I own or co-own the business
                  </span>
                </div>
              </div>
            </div>

            <div
              className={`select-role-outer-container ${
                formik.values.selectedRole === "member" ? "selected-role" : ""
              }`}
              onClick={() => handleRoleSelect("member")}
            >
              <img
                src={managerIcon}
                alt="managerIcon"
                // style={{ width: "4%" }}
              />
              <div className="role-text-checkbox-container">
                <div className="role-text-content">
                  <h3 className="signup-main-header">
                    I'm a user of an organisation
                  </h3>
                  <span className="signup-side-text">
                    I manage hiring for my team or department
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="signup-button-container">
            <Button
              isCancel={true}
              event={() => navigate("/")}
              label="Back"
              iconSrc={backIcon}
              iconPosition="left"
              iconWidth="22px"
            />
            <Button
              label="Continue"
              event={formik.handleSubmit}
              iconSrc={continueIcon}
              iconPosition="right"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignupType;
